import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import EditCardMenu from "./EditCardMenu";
import { toast } from "react-toastify";
import { checkErrorMessage, checkResponseData } from "../../../utils/utils";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import { Typography, IconButton, Divider, Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArchiveIcon from "@mui/icons-material/Archive";
// import AlertCards from "../AlertCards";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  answerCardApi,
  editCardApi,
  deleteCardApi,
} from "../../../../services/leitnerApi";
import { handleEdit } from "./editCardUtils";
import TopOfCards from "../TopOfCards";
import EditFrontCard from "./EditFrontCard";
import EditBackCard from "./EditBackCard";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function EditCards(props) {
  const { controlThemeMode, handleEditCard, cards, editCard } = props;
  const [editedItems, setEditedItems] = useState({});

  const handleEditedItems = (data) => {
    const newObj = { ...editedItems, ...data };
    setEditedItems(newObj);
  };
  const submitEditCard = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      if (Object.keys(editedItems).length > 0) {
        let cpEditedItems = { ...editedItems }
        if (cpEditedItems["backCard"].length > 0) {
          let newBackCard = cpEditedItems["backCard"].filter((value) => value.length > 0)
          cpEditedItems["backCard"] = newBackCard
          setEditedItems(cpEditedItems)
        }
        const response = await editCardApi({ cardId: editCard["card"]["_id"], ...cpEditedItems })
        let newAllcards = handleEdit(editCard["card"], cpEditedItems, cards);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          handleEditCard("doneEdit", newAllcards)
          toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });

        } else {
          toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        }
      } else {
        handleEditCard("cancelEdit");
        toast.update(toastMsg, { render: "ویرایشی انجام نشد", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      console.error(error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };
  // useEffect(() => {
  //   handleEditedItems({ frontCard: editCard["card"]["frontCard"] });
  //   handleEditedItems({ backCard: editCard["card"]["backCard"] });
  // }, []);

  // useEffect(() => {
  //   console.log("useEffect-setInfoAndCards");
  //   setInfoAndCards();
  // }, [studyCards]);
  // useEffect(() => {
  //   console.log("useEffect-pickNewCardFromCards");
  //   if (cards) pickNewCardFromCards();
  // }, [cards]);

  return (
    <>
      <EditCardMenu
        controlThemeMode={controlThemeMode}
        submitEditCard={submitEditCard}
      />
      <CssBaseline />
      <Stack
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        spacing={0.5}
        sx={{ p: 1 }}
      >
        <EditFrontCard
          pickCard={editCard["card"]}
          handleEditedItems={handleEditedItems}
        />
        <EditBackCard
          pickCard={editCard["card"]}
          handleEditedItems={handleEditedItems}
        />
      </Stack>
      <Paper
        sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
        elevation={3}
      >
        <BottomNavigation
          showLabels
          // value={value}
          onChange={(event, newValue) => {
            // handleShowAnswer(false);
          }}
        >
          <BottomNavigationAction
            label="ذخیره"
            icon={<SaveIcon />}
            sx={{
              bgcolor: "#a70000",
              color: "white",
              mx: 1,
              borderRadius: "15%",
            }}
            onClick={() => {
              submitEditCard();
            }}
          />
          <BottomNavigationAction
            label="لغو"
            sx={{
              bgcolor: "#a34f01",
              color: "white",
              mx: 1,
              borderRadius: "15%",
            }}
            icon={<CancelIcon />}
            onClick={() => {
              handleEditCard("cancelEdit");
            }}
          />
        </BottomNavigation>
      </Paper>
      {/* <AlertCards /> */}
    </>
  );
}
